

export const AmexOld = ()=>{

    return(
        <div>This is Amex old gateway... (deprecated)</div>
    )
}